module.exports = __webpack_public_path__ + "static/media/accessory25.d30ef909.webp";